import React, { useState, useEffect, Suspense, lazy } from "react";
import Preloader from "./components/Pre";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

// ── Lazy-load every page — only loaded when the user navigates to it ──────────
const Home    = lazy(() => import("./components/Home/Home"));
const About   = lazy(() => import("./components/About/About"));
const Projects = lazy(() => import("./components/Projects/Projects"));
const Resume  = lazy(() => import("./components/Resume/ResumeNew"));
const Gallery = lazy(() => import("./components/Gallery/Gallery"));
const Contact = lazy(() => import("./components/Contact/Contact"));
const Footer  = lazy(() => import("./components/Footer"));

// ── Lightweight fallback while a page chunk loads ─────────────────────────────
function PageSkeleton() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "#09090b",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <div style={{
        width: 40, height: 40,
        borderRadius: "50%",
        border: "3px solid #27272a",
        borderTopColor: "#3b82f6",
        animation: "spin 0.7s linear infinite",
      }} />
    </div>
  );
}

function App() {
  const [load, setLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoad(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Suspense fallback={<PageSkeleton />}>
          <Routes>
            <Route path="/"        element={<Home />} />
            <Route path="/project" element={<Projects />} />
            <Route path="/about"   element={<About />} />
            <Route path="/resume"  element={<Resume />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*"        element={<Navigate to="/" />} />
          </Routes>
          <Footer />
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
